import { Button, DialogActions, Box, Typography, useTheme } from "@mui/material";
import { FoodsIcon } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

type Props = {
    commentId?: string;
    comment?: string;
    newComment: string;
    onCancel: () => void;
    onDeleteClick: () => void;
    onSave: () => void;
    onDeleteAndSave: () => void;
};

export const CommentDialogActions = ({
    commentId,
    comment,
    newComment,
    onCancel,
    onDeleteClick,
    onSave,
    onDeleteAndSave,
}: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <DialogActions
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderTop: `solid ${theme.palette.grey[800]} ${theme.spacing(0.1)}`,
                minHeight: `${theme.spacing(8)}`,
                padding: `${theme.spacing(3)}`,
            }}
        >
            <Button onClick={onCancel} variant="text" sx={{ gap: theme.spacing(1) }}>
                <Typography variant="body-bold" sx={{ fontWeight: 700, color: theme.palette.primary[700] }}>
                    {t("glossary.cancel")}
                </Typography>
                <FoodsIcon size={1} icon="close" />
            </Button>

            <Box sx={{ gap: theme.spacing(2), display: "flex" }}>
                {commentId && (
                    <Button onClick={onDeleteClick} variant="ternary">
                        <FoodsIcon icon="delete" size={2} />
                        <Typography sx={{ marginLeft: theme.spacing(1), fontWeight: 700 }} variant="body-bold">
                            {t("property.note.delete_note")}
                        </Typography>
                    </Button>
                )}

                {commentId && newComment && (
                    <Button onClick={onDeleteAndSave} variant="primary" disabled={newComment === comment}>
                        <Typography variant="body-bold" sx={{ color: theme.palette.common.white }}>
                            {t("glossary.save_changes")}
                        </Typography>
                    </Button>
                )}

                {!commentId && (
                    <Button onClick={onSave} variant="primary" disabled={!newComment}>
                        <Typography variant="body-bold" sx={{ color: theme.palette.common.white }}>
                            {t("glossary.add")}
                        </Typography>
                    </Button>
                )}
            </Box>
        </DialogActions>
    );
};
